import { Pipe, PipeTransform } from '@angular/core';
import { App } from '@df/core/app';
import { Nexus } from '@tomandco/nexus-api-types';
import compact from 'lodash-es/compact';

declare module '@tomandco/nexus-api-types' {
    namespace Nexus.Lib.General {
        interface AppData {
            prioritized_countries: string[];
        }
    }
}
@Pipe({
    name: 'pushCountriesToFront',
    standalone: true
})
export class PushCountriesToFrontPipe implements PipeTransform {
    constructor(readonly app: App) {}
    transform(countries: Nexus.Lib.General.Country[], codes?: string[]) {
        if (!codes) {
            codes = this.app.data.prioritized_countries || [];
        }
        const _countries: Nexus.Lib.General.Country[] = [...countries]; // immutable
        const removed = _countries.filter(country => !codes?.includes(country.code));
        const added = _countries
            .filter(country => codes?.includes(country.code))
            .sort((a, b) => codes.indexOf(a.code) - codes.indexOf(b.code));
        return compact([...added, added.length && removed.length ? { code: 'divider', name: 'disabled' } : undefined, ...removed]);
    }
}
